import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Hero() {
  return <div className="w-full px-6 py-24 md:py-32 relative overflow-hidden bg-gradient-to-br from-blue-50 via-purple-50 to-pink-50" data-id="element-69">
      {/* Vibrant Background Elements */}
      <div className="absolute inset-0 opacity-60" data-id="element-70">
        <div className="absolute top-20 right-1/4 w-96 h-96 bg-gradient-to-br from-blue-400 to-cyan-300 rounded-full mix-blend-multiply filter blur-3xl animate-blob" data-id="element-71"></div>
        <div className="absolute top-40 left-1/3 w-96 h-96 bg-gradient-to-br from-purple-400 to-pink-300 rounded-full mix-blend-multiply filter blur-3xl animate-blob animation-delay-2000" data-id="element-72"></div>
        <div className="absolute bottom-20 left-1/4 w-96 h-96 bg-gradient-to-br from-cyan-300 to-blue-400 rounded-full mix-blend-multiply filter blur-3xl animate-blob animation-delay-4000" data-id="element-73"></div>
      </div>
      <div className="max-w-6xl mx-auto relative z-10" data-id="element-74">
        <div className="text-center space-y-8" data-id="element-75">
          <div className="inline-flex items-center gap-2 bg-blue-50 border border-blue-100 text-blue-700 px-5 py-2.5 rounded-full text-sm font-medium" data-id="element-76">
            <ShieldCheckIcon className="w-4 h-4" data-id="element-77" />
            Modern Travel Tech Solutions
          </div>
          <h1 className="text-5xl md:text-7xl font-bold text-slate-900 leading-tight tracking-tight" data-id="element-78">
            Travel Smarter with
            <span className="block text-blue-600 mt-2" data-id="element-79">Pomelo Services</span>
          </h1>
          <p className="text-xl md:text-2xl text-slate-600 max-w-3xl mx-auto leading-relaxed" data-id="element-80">
            Deliver smooth, secure travel experiences worldwide using a modern
            payments stack built for today's travel platforms.
          </p>
          <div className="flex justify-center items-center pt-6" data-id="element-81">
            <a href="mailto:enquiries@pomeloservices.uk" className="bg-blue-600 text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-blue-700 transition-all duration-200 inline-flex items-center gap-2 shadow-lg shadow-blue-600/20" data-id="element-82">
              Contact Sales
            </a>
          </div>
        </div>
      </div>
    </div>;
}